export const SET_STATUS="app/assets/SET_STATUS"
export const NEXT_PAGE="app/assets/NEXT_PAGE"
export const BACK_PAGE="app/assets/BACK_PAGE"
export const RESET_PAGE="app/assets/RESET_PAGE"
export const ASSET_LOADING="app/assets/ASSET_LOADING"
export const SET_SEARCH="app/assets/SET_SEARCH"
export const SET_SEARCH_VIEW="app/assets/SET_SEARCH_VIEW"
